import { X } from "lucide-react";

export const INP = "w-full px-3 py-2 bg-white border border-slate-200 rounded-sm text-sm outline-none focus:border-[#1E2A78]";
export const LBL = "block text-[10px] font-semibold uppercase tracking-wider text-slate-500 mb-1";

export function fmtDate(iso) {
  if (!iso) return "—";
  try { return new Date(iso).toLocaleString(); } catch { return iso; }
}

export function StatusBadge({ status }) {
  const map = {
    new: "bg-[#FFD700]/20 text-[#1E2A78] border-[#FFD700]",
    in_progress: "bg-blue-50 text-blue-700 border-blue-200",
    completed: "bg-green-50 text-green-700 border-green-200",
    rejected: "bg-red-50 text-red-700 border-red-200",
  };
  return <span className={`inline-flex items-center px-2 py-0.5 rounded-sm border text-[10px] uppercase tracking-wider font-semibold ${map[status] || "bg-slate-100 text-slate-700 border-slate-200"}`}>{status}</span>;
}

export function StatusSelect({ value, onChange, testId }) {
  return (
    <select onChange={(e) => onChange(e.target.value)} value={value} className="text-xs px-2 py-1 border border-slate-200 rounded-sm" data-testid={testId}>
      <option value="new">new</option>
      <option value="in_progress">in_progress</option>
      <option value="completed">completed</option>
      <option value="rejected">rejected</option>
    </select>
  );
}

export function Modal({ title, onClose, children, wide = false }) {
  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4" onClick={onClose}>
      <div className={`bg-white rounded-sm ${wide ? "max-w-5xl" : "max-w-2xl"} w-full max-h-[90vh] overflow-y-auto`} onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between p-5 border-b border-slate-200 sticky top-0 bg-white z-10">
          <h3 className="font-display font-bold text-lg">{title}</h3>
          <button onClick={onClose} className="p-1 hover:bg-slate-100 rounded-sm" data-testid="modal-close"><X className="h-5 w-5" /></button>
        </div>
        <div className="p-5">{children}</div>
      </div>
    </div>
  );
}
